import { api } from 'src/plugins/axios'
import Vue from 'vue'
import { notify } from 'src/plugins/notify'
import { createQueryString, serializeObject } from 'src/utils'
const moment = require('moment')

export default {
  add,
  addNew,
  select,
  fetch,
  fetchStudentClasses,
  fetchAutoComplete,
  create,
  update,
  remove,
  clearAllForms
}

async function addNew ({ commit, dispatch, state }) {
  console.log('clearing')
  dispatch('clearAllForms')
  commit('students/openStudentModal', { module, mode: 'add' }, { root: true })
}

async function add ({ commit, dispatch, state }) {
  const response = await dispatch('create')
  if (response.success) dispatch('clearAllForms')
  return response
}

async function select ({ commit, dispatch, state }, payload) {
  let vm = this._vm
  vm.$q.loading.show({
    message: "Loading Student"
})
  dispatch('clearAllForms')
  let response = await api.post('/student/one/', { id: payload.STUDENT_ID })
  const { student, studentAddresses, approvals, driversLicense } = response.data.payload

  // check if student is in an approved class
  if (approvals.includes(2)) {
    commit('inApprovedClass')
  }

  const billingAddress = studentAddresses.find(function (addr) {
    return addr.LK_ADDRESS_TYPE_ID === 3
  })
  const shippingAddress = studentAddresses.find(function (addr) {
    return addr.LK_ADDRESS_TYPE_ID === 2
  })
  if (billingAddress) commit('setAddressForm', { form: 'billingAddressForm', address: billingAddress.ADDRESS })
  if (shippingAddress) commit('setAddressForm', { form: 'shippingAddressForm', address: shippingAddress.ADDRESS })
  if (billingAddress) {
    if (shippingAddress && shippingAddress.ADDRESS_ID === billingAddress.ADDRESS_ID) {
      commit('setSameAsBilling', { status: true })
    }
  }

  if (driversLicense) commit('setDriversLicenseForm', { driversLicense })

  student.STUDENT_DOB = moment(student.STUDENT_DOB).format('L')
  commit('setStudentForm', { student: student })
  commit('students/openStudentModal', { module, mode: 'edit' }, { root: true })
  vm.$q.loading.hide()
}

async function fetch ({ commit, state }, { pagination, filter, columns, exportOptions }) {
  commit('isLoading')
  try {
    const query = createQueryString({ pagination, filter, columns, exportOptions })
    let fieldQuery
    const searchFields = state.searchFields
    let finalSearchFields = _.pickBy(searchFields, v => {
      return v !== null && v !== '' && (typeof v === 'string' ? v.trim() !== '' : 1)
    })
    if (!_.isEmpty(finalSearchFields)) {
      fieldQuery = serializeObject({searchFields:{...finalSearchFields}})
    }
    let finalQuery = query + (fieldQuery ? '&' + fieldQuery : '')
    const { data: response } = await api.get('/student/fetch/' + finalQuery)
    const { success, payload } = response
    commit('doneLoading')
    if (!success) throw response

    if (!exportOptions) commit('setList', { students: payload.students })
    // notify.respond(response)
    return response
  } catch (response) {
    commit('doneLoading')
    // notify.respond(response)
    return response
  }
}

async function fetchStudentClasses ({ commit, state }, { pagination, filter, columns }) {
  commit('isLoading')  

  try {
    commit('setStudentClassList', { classes: [] })
    
    const customFilter = [{"field":"STUDENT_ID","filter": state.studentForm.STUDENT_ID}]
    let query = createQueryString({ pagination, filter, columns, customFilter })
    const { data: response }  = await api.get('/student/fetchStudentClasses' + query)
    const { success, payload } = response
    console.log(payload)
    commit('doneLoading')
    commit('setStudentClassList', { classes: payload.rows })
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function fetchAutoComplete ({ commit, dispatch, state }, { s }) {
  try {
    const { data: response } = await api.post('/student/autocomplete', { s })
    commit('setAutoCompleteList', { students: response.payload })
  } catch (err) {

  }
}

async function create ({ commit, dispatch, state }) {
  const { studentForm, addressForm, driversLicenseForm } = state
  studentForm.STUDENT_DOB = new Date(studentForm.STUDENT_DOB).toISOString()

  const form = {
    studentForm,
    addressForm,
    driversLicenseForm
  }

  try {
    const { data: response } = await api.post('/student/create', { form })
    const { success, payload } = response
    if (!success) throw response

    console.log('payload', payload)

    commit('students/updateStudentForm', { field: 'STUDENT_ID', value: payload.STUDENT_ID }, { root: true })
    commit('students/updateAddressForm', { field: 'ADDRESS_ID', value: payload.ADDRESS_ID }, { root: true })
    dispatch('students/fetch', {}, { root: true })
    //commit('students/closeDetails', {}, { root: true })

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function update ({ commit, dispatch, state, rootState }) {
  const { studentForm, billingAddressForm, shippingAddressForm, driversLicenseForm } = state
  
  const form = {
    studentForm,
    billingAddressForm,
    shippingAddressForm,
    driversLicenseForm
  }
  try {
    const { data: response } = await api.post('/student/update', { form })
    const { success } = response
    if (!success) throw response
    
    dispatch('fetch', {})
    commit('students/closeDetails', {}, { root: true })
    notify.respond(response)
    
    /**
     * Update the completion report modal if it's open.
     * Mutations dont have rootState 🤷🏽‍
     */
    try{
      if(rootState.shared.studentCompletionModal){
        if(studentForm.STUDENT_ID){
          
          let studentIndex = _.findIndex(rootState.reports.studentCompletionList, x => {
                let matchingID = _.findIndex(x,{field:"STUDENT_ID", value: studentForm.STUDENT_ID})
                return matchingID > -1
              })
          console.log(studentIndex)
          if(studentIndex > -1){
            let existingCompletionStudent = rootState.reports.studentCompletionList[studentIndex]
            let newUpdatedData = [
              // f = field,  d = data
              buildCompletionData({f:'LAST_NAME', d: studentForm.STUDENT_LAST_NAME}),
              buildCompletionData({f:'FIRST_NAME', d: studentForm.STUDENT_FIRST_NAME}),
              buildCompletionData({f:'MIDDLE_NAME', d: studentForm.STUDENT_MIDDLE_NAME}),
              buildCompletionData({f:'DOB', d: studentForm.STUDENT_DOB}),
              buildCompletionData({f:'GENDER', d: studentForm.STUDENT_GENDER}),
              buildCompletionData({f:'DRIVERS_LICENSE', d: driversLicenseForm.DRIVERS_LICENSE}),
              buildCompletionData({f:'COMPLETED_DATE', d: getExistingCompletionData(existingCompletionStudent,'COMPLETED_DATE') }),
              buildCompletionData({f:'SPONSOR_CODE', d: getExistingCompletionData(existingCompletionStudent,'SPONSOR_CODE') }),
              buildCompletionData({f:'AFFILIATE_CODE', d: getExistingCompletionData(existingCompletionStudent,'AFFILIATE_CODE') }),
              buildCompletionData({f:'CLASSROOM', d: 'C' }),
              buildCompletionData({f:'STUDENT_ID', d: studentForm.STUDENT_ID })
            ]
            
            Vue.set(rootState.reports.studentCompletionList, studentIndex, newUpdatedData)
            
          }
          
        }
      }
    }
    catch(err){
      /// Dont want to throw any parsing errors to the user.
      console.log(err)
    }
    
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

function buildCompletionData({f, d}){
  return {
    field: f,
    value: d,
    exception: (f === 'MIDDLE_NAME' || d) ? false : true
  }
}

function getExistingCompletionData(student, key){
  return _.find(student,{field:key}).value
}

async function remove ({ commit, dispatch, state }) {
  const { studentForm, billingAddressForm, shippingAddressForm, driversLicenseForm } = state
  const { STUDENT_ID } = studentForm
  const { BILLING_ADDRESS_ID } = billingAddressForm
  const { SHIPPING_ADDRESS_ID } = shippingAddressForm
  const { DRIVERS_LICENSE_ID } = driversLicenseForm

  try {
    const { data: response } = await api.post('/student/remove', { STUDENT_ID, BILLING_ADDRESS_ID, SHIPPING_ADDRESS_ID, DRIVERS_LICENSE_ID })
    const { success } = response
    if (!success) throw response

    dispatch('fetch', {})
    commit('students/closeDetails', {}, { root: true })
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

function clearAllForms ({ commit, state }) {
  commit('clearStudentForm')
  commit('clearAddressForms')
  commit('clearDriversLicenseForm')
}
